import React from "react";
import { Button } from "./ui/button";
import { Link } from "react-router-dom";

// let button = document.querySelector('.button');
// let testA = document.querySelector('a.net');
// let backgroundButton = document.querySelector('.background__button');

//   button.addEventListener('mouseenter', function(){
//     testA.classList.add('is-white')
//     backgroundButton.classList.add('is-hover');
//   });

//   button.addEventListener('mouseleave', function(){
//     testA.classList.remove('is-white')
//     backgroundButton.classList.remove('is-hover');
//   });
function NetButton({ onlyTimer }) {
  return (
    <main className={`${onlyTimer ? "hide-toggle" : "open-toggle"}`}>
      <a
        rel="noopener noreferrer"
        href="https://www.crunchyroll.com/"
        target="_blank"
      >
        <Button className="hover:scale-110 transition-all border !border-neutral-800 p-0 overflow-hidden rounded-md w-24 h-10">
          <img
            src="/crunchyroll.avif"
            alt=""
            className="  bg-center bg-contain"
          />
        </Button>
      </a>
    </main>
  );
}
export default NetButton;
{
  /* <div class="button">
        <a
          class="net"
          href="https://www.netflix.com/in/browse/genre/7424"
          target="_blank"
          rel="noopener noreferrer"
        >
          NETFLIX
        </a>
        <div class="background__button"></div>
      </div> */
}
